module.exports = __webpack_public_path__ + "img/tempo_logo.ec7659dc.svg";